import React,{useEffect,useState} from 'react';
import {BrowserRouter} from 'react-router-dom';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import InitializeRoutes from './InitializeRoutes'

import {theme} from '../Theme/theme';
import {Grow } from '@mui/material';

import {Auth} from '../Api/auth';
import AuthSession from '../Components/AzureAD/AuthSession';
import SignInButton from '../Components/AzureAD/SignInButton';

// MSAL imports
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

// MSAL imports
import msalConfig from '../Components/AzureAD/AuthConfig';
import loginRequest from '../Components/AzureAD/AuthConfig';



export default function AppRouter() {

    const [state, setState] = React.useState({
        refreshUI: false
      });

    const msalInstance = new PublicClientApplication(msalConfig);

    const vettingAccounts = msalInstance.getAllAccounts();
    if (vettingAccounts.length > 0) {
      msalInstance.setActiveAccount(vettingAccounts[0]);
    }

    // Watch for logins from other tabs and windows
    msalInstance.enableAccountStorageEvents();

    msalInstance.addEventCallback((event) => {
        switch(event.eventType){
            case EventType.LOGIN_SUCCESS:
                const { account } = event.payload;
                msalInstance.setActiveAccount(account);
                
            case EventType.ACQUIRE_TOKEN_BY_CODE_SUCCESS:
                //Auth.login(event.payload.accessToken)

                Auth.authorizedFetch("/createUserSession",{},msalInstance)
                .then((response)=> {
                    if(!response.ok){
                        
                        //restart the whole login process
                        Auth.logout()
                        window.location.reload()
                        //throw Error(response.statusText)
                    }
                    else{
                        updateUI();
                        
                    }
                
                })
        }

    });

function updateUI(){
    setState({...state,refreshUI:true})
}
    return (
    
        <MsalProvider instance={msalInstance}>
            <AuthenticatedTemplate>
                {msalInstance.getAllAccounts().length > 0 &&
                            (<AuthSession>
                            
                            <BrowserRouter>
                                <StyledEngineProvider injectFirst>
                                    <ThemeProvider theme={theme}>
                                        <InitializeRoutes />
                                    </ThemeProvider>
                                </StyledEngineProvider>
                            </BrowserRouter>

                            </AuthSession>)
                }
           
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <SignInButton updateUI={updateUI} />
            </UnauthenticatedTemplate>
        </MsalProvider>

    )

}